import { EmptySearch } from "components/Illustrations/EmptySearch";

export const ChatFilterError = () => (
  <div className="t-flex t-h-full t-flex-col t-items-center t-justify-center t-gap-2 t-px-4 t-text-center">
    <EmptySearch />
    <span className="t-text-subtitle">Couldn't apply these filters</span>
    <span className="t-text-body-sm t-text-text-30">
      Something went wrong on our side. Change a filter to try again.
    </span>
  </div>
);
